import { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';

interface AuthConfigResult {
  success: boolean;
  message?: string;
  error?: string;
  code?: string;
  config?: {
    site_url: string;
    redirect_urls: string[];
    origin: string;
  };
}

export const useAuthStartupConfig = () => {
  const [isConfiguring, setIsConfiguring] = useState(false);
  const [configResult, setConfigResult] = useState<AuthConfigResult | null>(null);

  useEffect(() => {
    // Auth redirect URLs / site URL are managed in the Supabase Dashboard
    // (Auth → URL Configuration). The Supabase Auth API `/auth/v1/settings`
    // endpoint is read-only, so there is no runtime configuration to perform.
    // This hook is intentionally a no-op to avoid startup errors / blank screens.
    setConfigResult({ success: true, message: 'Auth config managed in dashboard' });
  }, []);

  return {
    isConfiguring,
    configResult,
    isConfigured: configResult?.success || false
  };
};